module.exports = __webpack_public_path__ + "img/kurumsal_performans_ikon.5c496afd.jpg";